export const isFacebookLoginEnabled = false;
export const isVideoEnabled = false;
